export const seekerHero = {
  title: "Master your career without hunting listings",
  subtitle:
    "Build a verified profile once. When you are ready, CareerMaster brings relevant opportunities to you — FTE, contract, and soft-job engagements alike.",
};

export const seekerFeatures = [
  {
    title: "No job-board grind",
    body: "You do not search endless listings. You set readiness and preferences; matching works for you.",
  },
  {
    title: "Verified profile and skills",
    body: "Employment history, skills, and proof create a career signal employers can trust.",
  },
  {
    title: "Opportunities when you are ready",
    body: "Stay quiet while you are settled. Turn interest on when you want to hear about fits.",
  },
  {
    title: "Placement and soft jobs",
    body: "Traditional roles and discovery or modernization engagements — matched to how you work, not just keywords.",
  },
  {
    title: "Coaching and proof",
    body: "Strengthen how you present yourself and demonstrate capability where it matters.",
  },
];

export const seekerSteps = [
  {
    step: 1,
    title: "Create your account",
    body: "Register and start your CareerMaster profile.",
  },
  {
    step: 2,
    title: "Build verified career data",
    body: "Add employment, skills, education, and preferences that describe real fit.",
  },
  {
    step: 3,
    title: "Set your readiness",
    body: "Control whether you want to hear about new opportunities.",
  },
  {
    step: 4,
    title: "Review matches that find you",
    body: "When roles or soft-job engagements fit, you review them — you do not browse a board.",
  },
];
